import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3 mb-md-4" }
const _hoisted_4 = { class: "default-table-area manage-reviews-table" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table align-middle" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "ms-2 ps-1" }
const _hoisted_9 = { class: "fw-medium fs-14" }
const _hoisted_10 = { class: "text-body" }
const _hoisted_11 = { class: "d-flex align-items-lg-center flex-wrap gap-1 mb-2" }
const _hoisted_12 = { class: "mw-380" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "fs-15 fw-medium ms-2" }
const _hoisted_15 = { class: "d-block" }
const _hoisted_16 = { class: "d-block" }
const _hoisted_17 = { class: "d-flex align-items-center gap-3" }
const _hoisted_18 = {
  class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  "data-bs-title": "Approved"
}
const _hoisted_19 = { class: "material-symbols-outlined fs-16 text-primary" }
const _hoisted_20 = {
  class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  "data-bs-title": "Reply"
}
const _hoisted_21 = { class: "material-symbols-outlined fs-16 text-body" }
const _hoisted_22 = {
  class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  "data-bs-title": "Delete"
}
const _hoisted_23 = { class: "material-symbols-outlined fs-16 text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_PaginationTwo = _resolveComponent("PaginationTwo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "position-relative table-src-form me-0",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "Search here",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event))
          }, null, 512), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y" }, " search ", -1))
        ], 32),
        _cache[3] || (_cache[3] = _createStaticVNode("<select class=\"form-select month-select form-control\" aria-label=\"Default select example\"><option selected>Show All</option><option value=\"1\">Weekly</option><option value=\"2\">Monthly</option><option value=\"3\">Yearly</option></select>", 1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "Reviewer"),
                _createElementVNode("th", { scope: "col" }, "Review"),
                _createElementVNode("th", { scope: "col" }, "Product"),
                _createElementVNode("th", { scope: "col" }, "Date"),
                _createElementVNode("th", { scope: "col" }, "Status"),
                _createElementVNode("th", { scope: "col" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, {
                      to: "/my-profile",
                      class: "d-flex align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: item.reviewer.image,
                          class: "wh-40 rounded-circle",
                          alt: "user"
                        }, null, 8, _hoisted_7),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("h6", _hoisted_9, _toDisplayString(item.reviewer.name), 1),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(item.reviewer.email), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.ratings.stars, (content) => {
                        return (_openBlock(), _createElementBlock("i", {
                          key: content,
                          class: _normalizeClass([content.star, "fs-18 text-warning"])
                        }, null, 2))
                      }), 128))
                    ]),
                    _createElementVNode("p", _hoisted_12, _toDisplayString(item.ratings.review), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, {
                      to: "/ecommerce/product-details",
                      class: "d-flex align-items-center text-secondary hover"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: item.product.image,
                          class: "rounded-3 wh-40",
                          alt: "product"
                        }, null, 8, _hoisted_13),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(item.product.title), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(item.date.date), 1),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(item.date.time), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge bg-opacity-10 p-2 fs-12 fw-normal", _ctx.computeClass(item.status)])
                    }, _toDisplayString(item.status), 3)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("button", _hoisted_18, [
                        _createElementVNode("i", _hoisted_19, _toDisplayString(item.action.approved), 1)
                      ]),
                      _createElementVNode("button", _hoisted_20, [
                        _createElementVNode("i", _hoisted_21, _toDisplayString(item.action.reply), 1)
                      ]),
                      _createElementVNode("button", _hoisted_22, [
                        _createElementVNode("i", _hoisted_23, _toDisplayString(item.action.delete), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createVNode(_component_PaginationTwo, {
          items: "10",
          total: ""
        })
      ])
    ])
  ]))
}